import "whatwg-fetch";
import { optionsGen } from "../helpers/api";
import { toESQuery, toESGroupByQuery, toESDateHistogramQuery, toESDateHistogramGroupByQuery, toESDoubleGroupByQuery } from "../helpers/query";
import { toTitleCase } from "../helpers/converters";
import { uniq } from "lodash";
const AUTH = false;

function withDefaultFullTextFields(query) {
  return query.full_text ? { ...query, full_text_fields: ["attachments.attachment.content"] } : query;
}

export function esqDocuments(query, highlight = false) {
  return toESQuery(withDefaultFullTextFields(query), ["abstract", "attachments"], 20, highlight);
}

export function getDocuments(url, query) {
  return fetch(url, optionsGen("POST", esqDocuments(query, true), AUTH)).then(resp => resp.json());
}

export function getDistinctValues(url, field, queries) {
  return fetch(url, optionsGen("POST", toESGroupByQuery(field, queries, 20), AUTH))
    .then(resp => resp.json())
    .then(json => {
      return json.aggregations[field].buckets.map(e => toTitleCase(e.key));
    });
}

export function getDocumentsByDate(esUrl, queries, dateField, interval = "year") {
  let q = toESDateHistogramQuery(dateField, interval, withDefaultFullTextFields(queries));
  return fetch(esUrl, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json => json.aggregations[dateField].buckets);
}

export function getDocumentsByDateAndField(esUrl, queries, dateField, field2, interval = "year") {
  let q = toESDateHistogramGroupByQuery(dateField, field2, interval, withDefaultFullTextFields(queries));
  return fetch(esUrl, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json =>
      json.aggregations[dateField].buckets.map(b => ({
        key: b.key,
        key_as_string: b.key_as_string,
        value: b[field2].buckets.map(bb => ({
          key: bb.key,
          doc_count: bb.doc_count
        }))
      }))
    );
}

export function getDocumentsByField(esUrl, queries, field, size = 20) {
  let q = toESGroupByQuery(field, withDefaultFullTextFields(queries), size);
  return fetch(esUrl, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json => {
      let total = json.aggregations[field].sum_other_doc_count;
      json.aggregations[field].buckets.forEach(b => {
        total += b.doc_count;
      });
      return json.aggregations[field].buckets.map(b => ({
        ...b,
        doc_pct: b.doc_count / total
      }));
    });
}

function getDistinctField2Values(json, field1, field2) {
  let field2Values = [];
  json.aggregations[field1].buckets.forEach(b => {
    b[field2].buckets.forEach(bb => {
      field2Values.push(bb.key);
    });
  });
  return uniq(field2Values);
}

function expandField2(field2Values, b, field2, total) {
  let field2Count = {};
  b[field2].buckets.forEach(obj => (field2Count[obj.key] = obj.doc_count));
  return {
    key: b.key,
    value: field2Values.map(v => {
      return v in field2Count
        ? {
          key: v,
          doc_count: field2Count[v],
          doc_pct: field2Count[v] / total
        }
        : {
          key: v,
          doc_count: 0,
          doc_pct: 0
        };
    })
  };
}

export function getDocumentsByTwoFields(esUrl, queries, field1, field2, size = 10) {
  let q = toESDoubleGroupByQuery(field1, field2, withDefaultFullTextFields(queries), size);
  return fetch(esUrl, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json => {
      let total = json.aggregations[field1].sum_other_doc_count;
      json.aggregations[field1].buckets.forEach(b => {
        total += b.doc_count;
      });
      const field2Values = getDistinctField2Values(json, field1, field2);
      return json.aggregations[field1].buckets.map(b => expandField2(field2Values, b, field2, total));
    });
}
